// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';
import React, { Component } from "react";
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import FileUploadWithDrag from 'share/components/controls/FileUploadWithDrag/Izenda.FileUploadWithDrag';
import PropTypes from 'prop-types';
import { omit } from 'lodash/fp';

@connect()
export default class FileUploadPopup extends Component {

  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired
  };

  /**
   * Close current popup.
   */
  closePopup = () => {
    this.props.onAccept();
  };

  /**
   * Success uploading handler: close the popup and call handler.
   * @param content
   */
  onSuccessInner = content => {
    const { onSuccess } = this.props;
    this.closePopup();
    onSuccess && onSuccess(content);
  };

  /**
   * Error uploading handler: close the popup and call handler.
   * @param error
   */
  onErrorInner = error => {
    const { onError } = this.props;
    this.closePopup();
    onError && onError(error);
  };

  /**
   * Render connection string builder modal
   * @returns {Object}
   */
  render() {
    const props = this.props;
    const { localization } = props;
    const rest = omit(['onSuccess', 'onError'], props);

    return (
      <Popup visible onClosing={this.closePopup} type='none' autoClose={false}>
        <Popup.Header title={localization.getText('CONNECTION_STRING_BUILDER_LABEL_DATABASE_CONNECTION')} />
        <Popup.Body>
          <FileUploadWithDrag
            onSuccess={this.onSuccessInner}
            onError={this.onErrorInner}
            {...rest}
          />
        </Popup.Body>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/FileUploadPopup/Izenda.FileUploadPopup.js